import webcrypto from './webcrypto.js';
export default webcrypto;
//# sourceMappingURL=index.js.map